import { useRef, useEffect } from 'react';

export function useDidUpdateHook(effect: Function, deps: unknown[]) {
	const ref = useRef(false);

	useEffect(() => {
		if (ref.current) {
			effect();
		} else {
			ref.current = true;
		}
	}, deps);
}
